import React, {PureComponent} from 'react';
import {FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import messages from '../../../../../res/translations/messages';
import ShuffledChoiceType from '../ShuffledChoiceType';
import ShuffledOccurrenciesChoiceType from '../ShuffledOccurrenciesChoiceType';
import CommonFields from './CommonFields';
import Error from '../../../Error';
import InvertBatteryButton from '../InvertBatteryButton';

class Battery1Type extends PureComponent {
    constructor(props) {
        super(props);
        this.onInvert = this.onInvert.bind(this);
    }

    onInvert() {
        const {name, form} = this.props;
        const values = get(form.values, name);
        const {choices, rows} = values;
        form.setFieldValue(`${name}.rows`, choices, false);
        form.setFieldValue(`${name}.choices`, rows);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <h4 htmlFor={`${name}.choices`}>&gt; <FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
                        </div>
                        <div className="col-auto">
                            <InvertBatteryButton onClick={this.onInvert} />
                        </div>
                    </div>
                    <FieldArray name={`${name}.choices`} component={ShuffledOccurrenciesChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <h4 htmlFor={`${name}.rows`}>&gt; <FormattedMessage {...messages.surveys.form.label.rows} /></h4>
                        </div>
                        <div className="col-auto">
                            <InvertBatteryButton onClick={this.onInvert} />
                        </div>
                    </div>
                    <FieldArray name={`${name}.rows`} component={ShuffledChoiceType} previousPages={previousPages} />
                    <ErrorMessage name={`${name}.rows`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default Battery1Type;
